export const LOGO_COOKIE_KEY = 'pt-rt-300';

export function getCookie(name) {
    let cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        let nameEQ = name + "=";
        if (cookiePair[0].trim() === name || cookiePair[0].trim().indexOf(nameEQ) === 0) {
            return decodeURIComponent(cookiePair[1]);
        }
    }
    return null;
}
